import { createFileRoute } from "@tanstack/react-router"
import { DonationDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Action, Resource } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/donations/records/$donationUuid"
)({
  component: function DonationDetailRoute() {
    return (
      <AuthorizationGate resource={Resource.DONATION} action={Action.READ}>
        <DonationDetailPage />
      </AuthorizationGate>
    )
  },
})
